import { ButtonSecondary } from "components/Atoms/Button";
import { CopyToClipboardTooltip } from "components/Atoms/CopyToClipboardTooltip";
import { PhosphorCheckCircle, PhosphorHourglass } from "components/Atoms/PhosphorIcon";
import { PhosphorCopyButton } from "components/Atoms/PhosphorIconButton";
import { NoDataAvailableWarning } from "components/NoDataAvailableDiv";
import { Panel } from "components/panels";
import Table from "components/Tables/Table";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  participants: server.dto.AdvancingParticipant[]
  isLoading: boolean
  approverActions?: {
    onInvite: () => void
    onDelete: (participant: server.dto.AdvancingParticipant) => void
  }
}

export const AdvancingParticipantsPanel = ({ participants, isLoading, approverActions }: Props) => {
  return <Panel
    panelClassName="s1_panel"
    title={RESX.Advancing.Participants}
    button={approverActions && <ButtonSecondary label="Invite participant" onClick={approverActions.onInvite} />}
  >
    <Table<server.dto.AdvancingParticipant>
      variant="cards"
      hideHeader
      items={participants}
      isLoading={isLoading}
      hideNoDataAvailableDiv
      getKey={participant => participant.advancingParticipantId.toString()}
      onDelete={approverActions?.onDelete}
      columns={[{
        key: "participant",
        header: "",
        size: "1fr",
        render: participant => {
          const createdUtc = moment.utc(participant.createdUtc);
          return <div className="flex gap-small">
            {participant.linkedToUser
              ? <PhosphorCheckCircle iconSize="large" iconWeight="fill" iconColor="green" />
              : <PhosphorHourglass iconSize="large" iconColor="gray" />}
            <div className="flex-column gap-mini">
              <div>{participant.linkedToUser ? participant.linkedToUser.fullName : participant.email}</div>
              {participant.linkedToUser && <div className="text-sublabel">{participant.email}</div>}
              {!participant.linkedToUser && <div className="text-sublabel" title={formatWrittenDateTimeUtc(createdUtc)}>Invited {createdUtc.fromNow()}</div>}
            </div>
          </div>;
        }
      }, {
        key: "invitationLink",
        header: "",
        size: "30px",
        hidden: !approverActions,
        render: participant => <CopyToClipboardTooltip>
          {copy => <PhosphorCopyButton
            layout="in-square"
            title="Copy invitation link"
            onClick={() => copy(routes.advancing_InvitationLanding(participant.secret).absolute)} />}
        </CopyToClipboardTooltip>
      }]}
    />
    {!isLoading && participants.length === 0 && <NoDataAvailableWarning>There are no participants</NoDataAvailableWarning>}
  </Panel>;
};
